import React from "react";
// Components
import GruposTrabajo from "../grupo_trabajo/GruposTrabajo";

const GruposTrabajoDireccionGeneral = ({ ...props }) => {
  return <GruposTrabajo direccionGeneral={'14'} {...props}></GruposTrabajo>;
};

export default GruposTrabajoDireccionGeneral;
